// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Layout_wrap__3Y4cM","tablet":"Layout_tablet__2R7l_"};